import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import TruncatedPara from '../../component/TruncatedPara/TruncatedPara';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const Testimonial = () => {
  const [mainIndex, setMainIndex] = useState(0);

  const carouselData = [
    {
      feedback:
        'I would highly recommend Vinoth’s training program to anyone looking to improve their fitness, build strength, or achieve specific fitness goals. His knowledge, dedication, and results-driven approach make him one of the best trainers out there.',
      name: 'Harish',
      profession: ''
    },
    {
      feedback:
        'Helped me get back into a routine and lose the weight I wanted before my brother’s wedding. In just a matter of weeks, I was already seeing result and could see  my muscles toning. He made it easy to work with him over FaceTime and being on two different continents. His guidance and direction was easy to follow.',
      name: 'Yonella',
      profession: ''
    },
    {
      feedback:
        'One of my biggest achievements with Vinoth’s training has been building sustainable fitness habits and reaching my strength goals. I never thought I would be able to lift certain weights or achieve my current level of endurance, but with his guidance, I have surpassed my expectations.',
      name: 'Fayaz Mohammed',
      profession: ''
    },
    {
      feedback:
        'I’ve lost excess fat while gaining lean muscle, and my overall body definition has improved. My stamina and mobility have also increased, making everyday activities feel easier. My posture and flexibility have significantly improved as well.',
      name: 'Melwin',
      profession: ''
    },
    {
      feedback:
        'Diet plan was awesome as I thought idili is not useful but u included that and as a Malaysian, u gave me good exposure on how Indian meals can help in weight reduction',
      name: 'Dharshinie',
      profession: ''
    },
    {
      feedback:
        'I’ve had an incredible experience virtual training with Vinodh Jackson - Beat XFit. His coaching style is engaging, motivating, and tailored to individual needs, making every session both challenging and rewarding.',
      name: 'Sangeeta, London',
      profession: ''
    },
    {
      feedback:
        'began training with Jackson after losing my dad to COVID. In the aftermath, I struggled with weight gain and depression. From the moment we started working together, Jackson not only helped me shed the extra weight and get in the best shape of my life, but he also played a key role in helping me heal emotionally. His workouts were always engaging and fun, making it feel like I wasn’t struggling, even when pushing myself. Jackson truly listens to my needs, makes me feel at ease, and has been an incredible support throughout this journey. I’m so grateful to have him as my personal trainer!',
      name: 'Mercia Arul',
      profession: ''
    }
  ];

  const styles = {
    container: {
      width: '100%',
      position: 'relative',
      background: '#f5f5f5',
      padding: '50px 0px',
      boxSizing: 'border-box'
    },
    heading: {
      color: '#263434',
      fontSize: '32px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '30px'
    },
    card: {
      minHeight: '250px',
      margin: '10px',
      borderRadius: '12px',
      background: 'white',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      textAlign: 'center',
      border: '1px solid #26BDBE'
    },
    feedback: {
      fontFamily: 'Raleway, sans-serif',
      fontStyle: 'italic',
      lineHeight: '1.6',
      fontSize: '16px',
      color: '#555',
      margin: '0 auto'
    },
    name: {
      fontFamily: 'Raleway, sans-serif',
      fontWeight: '700',
      fontSize: '18px',
      color: '#222',
      marginTop: '15px'
    },
    profession: {
      fontFamily: 'Raleway, sans-serif',
      fontWeight: '400',
      fontSize: '14px',
      color: '#666',
      marginTop: '5px'
    },
    arrow: {
      position: 'absolute',
      top: '60%',
      zIndex: 1,
      backgroundColor: '#fff',
      borderRadius: '50%',
      padding: '10px',
      boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
      cursor: 'pointer'
    },
    leftArrow: {
      left: '10px',
      transform: 'translateY(-50%)'
    },
    rightArrow: {
      right: '10px',
      transform: 'translateY(-50%)'
    }
  };

  // Function to handle left arrow visibility
  const renderLeftArrow = () => {
    return mainIndex > 0 ? (
      <div
        style={{ ...styles.arrow, ...styles.leftArrow }}
        onClick={() => setMainIndex(mainIndex - 1)}
      >
        <ArrowBackIosNewIcon />
      </div>
    ) : null;
  };

  // Function to handle right arrow visibility
  const renderRightArrow = () => {
    return mainIndex < carouselData.length - 1 ? (
      <div
        style={{ ...styles.arrow, ...styles.rightArrow }}
        onClick={() => setMainIndex(mainIndex + 1)}
      >
        <ArrowForwardIosIcon />
      </div>
    ) : null;
  };

  return (
    <div style={styles.container}>
      <p style={styles.heading}>What Our Clients Say</p>

      <Carousel
        selectedItem={mainIndex}
        onChange={(index) => setMainIndex(index)}
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        autoPlay
        stopOnHover
        interval={4000}
        showIndicators
        centerMode
        centerSlidePercentage={60}
      >
        {carouselData.map((data, index) => {
          const { feedback, name, profession } = data;
          return (
            <div key={`main-slide-${index}`} style={styles.card}>
              <p style={styles.feedback}>
                <TruncatedPara
                  text={feedback}
                  profession={profession}
                  name={name}
                  maxLines={3}
                />
              </p>
              <p style={styles.name}>{name}</p>
              <p style={styles.profession}>{profession}</p>
            </div>
          );
        })}
      </Carousel>

      {/* Custom Left and Right Arrows */}
      {renderLeftArrow()}
      {renderRightArrow()}
    </div>
  );
};

export default Testimonial;
